var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"index_div"}},[_c('router-view',{on:{"showHistory":_vm.showHistoryModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }